/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesAssets.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Asset Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 07:29:03 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const AssetList = Loadable({
    loader: () => import('../containers/Assets/AssetListContainer'),
    loading: Loading,
});

export const AssetForm = Loadable({
    loader: () => import('../containers/Assets/AssetEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesAssets.js